import { EventFormAffinityLine } from 'Components/lines/event-form-affinity-line/EventFormAffinityLine';
export default EventFormAffinityLine;
